import {
  Radio as HeroUIRadio,
  RadioProps as HeroUIRadioProps,
  groupDataFocusVisibleClasses,
  hiddenInputClasses,
} from "@heroui/react";
import clsx from "clsx";

type Color = "primary";
type Size = "sm" | "lg";

export type RadioProps = Omit<
  HeroUIRadioProps,
  "color" | "size" | "onClick"
> & {
  color?: Color;
  onClick?: never;
  size?: Size;
};

export const Radio = ({ color, isInvalid, size, ...props }: RadioProps) => {
  return (
    <HeroUIRadio
      {...props}
      classNames={{
        wrapper: clsx(
          "rounded-full border-medium border-solid border-default group-data-[hover-unselected=true]:bg-default-100",
          {
            "h-4 w-4": size === "sm",
            "h-6 w-6": size === "lg",
            "group-data-[selected=true]:border-primary": color === "primary",
            "border-danger group-data-[selected=true]:border-danger": isInvalid,
            ...groupDataFocusVisibleClasses,
          },
        ),
        control: clsx(
          "scale-0 rounded-full opacity-0 group-data-[selected=true]:scale-100 group-data-[selected=true]:opacity-100",
          {
            "h-1.5 w-1.5": size === "sm",
            "h-2.5 w-2.5": size === "lg",
            "bg-primary text-primary-foreground": color === "primary",
            "border-danger bg-danger": isInvalid,
          },
        ),
        labelWrapper: clsx("", {
          "ml-1": size === "sm",
          "ms-2": size === "lg",
        }),
        label: clsx("text-gray-900", {
          "text-small": size === "sm",
          "text-large": size === "lg",
          "!text-gray-900": color === "primary",
        }),
        description: clsx("text-gray-600", {
          "text-tiny": size === "sm",
          "text-medium": size === "lg",
          "!text-gray-600": color === "primary",
        }),
        hiddenInput: hiddenInputClasses,
      }}
      data-testid={`${props.name}-${props.value}`}
    />
  );
};
